import React, { useState, useContext } from "react";
import api from "../../utils/Api";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom"; 
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";

function LoginForm() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (email.trim() === "") newErrors.email = "El campo email es obligatorio.";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "El email no es válido.";
    if (password.trim() === "") newErrors.password = "El campo contraseña es obligatorio.";
    else if (password.length < 6) newErrors.password = "La contraseña debe tener al menos 6 caracteres.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGeneralError("");
    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) return;

    try {
      const response = await api.post("/login", { email, password });
      const { token } = response.data;

      login(token);
      const decodedToken = jwtDecode(token);

      if (decodedToken.rol === "admin") {
        navigate("/admin");
      } else if (decodedToken.rol === "empleado") {
        navigate("/empleados");
      } else {
        navigate("/");
      }

      setEmail("");
      setPassword("");
      setErrors({});
    } catch (error) {
      if (error.response && error.response.data) {
        setErrors(error.response.data.errors || {});
        if (!error.response.data.errors) {
          setGeneralError(error.response.data.error || "Error al iniciar sesión. Inténtalo de nuevo.");
        }
      } else {
        setGeneralError("Error al iniciar sesión. Inténtalo de nuevo.");
      }
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <h2 className="mb-4 text-center" style={{ color: "#2C2C2C" }}>
            Iniciar Sesión
          </h2>
          <form
            onSubmit={handleSubmit}
            className="p-4 border rounded shadow-sm bg-white"
            style={{ borderColor: "#F5F5F5" }}
          >
            {/* Email */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label" style={{ color: "#2C2C2C" }}>
                Email:
              </label>
              <input
                type="email"
                id="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ borderColor: errors.email ? "#dc3545" : "#ccc" }}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            {/* Password */}
            <div className="mb-3">
              <label htmlFor="password" className="form-label" style={{ color: "#2C2C2C" }}>
                Contraseña:
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className={`form-control ${errors.password ? "is-invalid" : ""}`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ borderColor: errors.password ? "#dc3545" : "#ccc" }}
                />
                <button
                  type="button"
                  className="btn"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ borderColor: "#ccc", color: "#2C2C2C" }}
                >
                  <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                </button>
              </div>
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>

            {/* Submit */}
            <div className="d-grid mb-3">
              <button
                type="submit"
                className="btn"
                style={{ backgroundColor: "#FF7A00", color: "#fff", border: "none" }}
              >
                Iniciar Sesión
              </button>
            </div>

            {/* Registro */}
            <div className="text-center" style={{ color: "#2C2C2C", marginBottom: "10px" }}>
                ¿Has olvidado tu contraseña?{" "}
              <Link to="/reset-password" style={{ color: "#FF7A00", fontWeight: "500", textDecoration: "none" }}>
                 Recuperar cuenta
              </Link>
            </div>
            <div className="text-center" style={{ color: "#2C2C2C" }}>
              ¿No tienes cuenta aún?{" "}
              <Link to="/register" style={{ color: "#FF7A00", fontWeight: "500", textDecoration: "none" }}>
                Regístrate
              </Link>
            </div>
          </form>

          {generalError && (
            <div className="mt-3 text-center">
              <div className="alert alert-danger">{generalError}</div>
            </div>
          )}
        </div>
      </div>
      <div className="text-center mt-4">
        Ver la documentación completa{" "}
        <Link to="/docs" style={{ color: "#FF7A00", fontWeight: "500", textDecoration: "none" }}>
          aquí
        </Link>.
      </div>
    </div>
  );
}

export default LoginForm;
